import BillPay from '../../components/BillPayComponent/BillPay';
import { BillPayType } from './billpay.type';



const INITIAL_STATE = {


    //billpay Transfer



    transferTotalAmount2: '',
    surcharge2: '',
    orderId2: '',
    amount2: '',
    createOrderReq2: '',
    createOrderRes2: '',
    createOrderStatusResponse2: '',
    createOrderResponseDetails2: '',
    moneyTransferProgress2: '',
    billpayAmount: '',
    biillpayOperator: '',
    biillpayOperatorCateGoryCode: '',
    billPayMobile: '',
    billPayOptional: '',
    billpayTxnHistory: '',

    formDate: '',
    toDate: '',

    curBillerName: '',
    billFetchParams:''

};

const billpayReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {



        //billpay Transfer
        case BillPayType.setMoneyTransferTotalAmount2:
            return {
                ...state,
                transferTotalAmount2: action.payload,
            };

        case BillPayType.setMoneyTransferSurChargeAmount2:
            return {
                ...state,
                surcharge2: action.payload,
            };

        case BillPayType.showCreateOrderResponse2:
            return {
                ...state,
                createdOrderResponse2: action.payload,
            };

        case BillPayType.setOrderId2:
            return {
                ...state,
                orderId2: action.payload,
            };

        case BillPayType.selectedRechargableAmnt2:
            return {
                ...state,
                billpayAmount: action.payload,
            };


        case BillPayType.setMoneyTransferTotalAmount2:
            return {
                ...state,
                transferTotalAmount2: action.payload,
            };

        case BillPayType.setMoneyTransferSurChargeAmount2:
            return {
                ...state,
                surcharge2: action.payload,
            };

        case BillPayType.setBillPayOperator:
            return {
                ...state,
                biillpayOperator: action.payload,
            };

        case BillPayType.setSelectedBillerCategoryCode:
            return {
                ...state,
                biillpayOperatorCateGoryCode: action.payload,
            };
        case BillPayType.setBillPayMobile:
            return {
                ...state,
                billPayMobile: action.payload,
            };
        case BillPayType.setBillPayOptional:
            return {
                ...state,
                billPayOptional: action.payload,
            };



        case BillPayType.setAmount2:
            return {
                ...state,
                amount2: action.payload,
            };


        case BillPayType.setStatusEnqResponse2:
            return {
                ...state,
                createOrderStatusResponse2: action.payload,
            };

        case BillPayType.setCreteOrderReq2:
            return {
                ...state,
                createOrderReq2: action.payload,
            };

        case BillPayType.setCreateOrderRes2:
            return {
                ...state,
                createOrderRes2: action.payload,
            };
        case BillPayType.setBillPayTxnHistory:
            return {
                ...state,
                billpayTxnHistory: action.payload,
            };

        case BillPayType.setMoneyTransferProgress2:
            return {
                ...state,
                moneyTransferProgress2: action.payload,
            };
        case BillPayType.setFilterEndDate:
            return {
                ...state,
                toDate: action.payload,
            };
        case BillPayType.setFilterStartDate:
            return {
                ...state,
                formDate: action.payload,
            };

        case BillPayType.setCurrentBillerName:
            return {
                ...state,
                curBillerName: action.payload,
            };

        case BillPayType.setBillFetchAllParam:
            return {
                ...state,
                billFetchParams: action.payload,
            };

        //setSelectedBillerCategoryCode
        case BillPayType.RESET:
            return INITIAL_STATE;


        default:
            return state;
    }

};

export default billpayReducer; 